import React, { useContext, useRef, useState, useEffect  } from "react";
import { Tensor, InferenceSession } from "onnxjs";
import On from './onnx_model.onnx'
import './style.css'

const CanvasContext = React.createContext();

export const Demo1 = ({ children }) => {
  const [isDrawing, setIsDrawing] = useState(false)
  const canvasRef = useRef(null);
  const contextRef = useRef(null);
  const CANVAS_SIZE = 280;
  const CANVAS_SCALE = 0.5;
  const sess = new onnx.InferenceSession();
  const loadingModelPromise = sess.loadModel(On);

  useEffect(() => {
    const canvas = canvasRef.current
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    canvas.style.width = `${CANVAS_SIZE}px`;
    canvas.style.height = `${CANVAS_SIZE}px`;

    const context = canvas.getContext("2d")
    context.lineWidth = 5;
    context.strokeStyle = "#212121"
    context.lineJoin = "round";
    context.font = "28px sans-serif";
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.fillStyle = "#212121";
    contextRef.current = context;
    }, []);

  const startDrawing = ({ nativeEvent }) => {
    const { offsetX, offsetY } = nativeEvent;
    contextRef.current.beginPath();
    contextRef.current.moveTo(offsetX, offsetY);
    setIsDrawing(true);
  };

  const finishDrawing = () => {
    contextRef.current.closePath();
    // updatePredictions()
    setIsDrawing(false);

  };

  const draw = ({ nativeEvent }) => {
    if (!isDrawing) {
      return;
    }
    const { offsetX, offsetY } = nativeEvent;
    contextRef.current.lineTo(offsetX, offsetY);
    contextRef.current.stroke();
    updatePredictions()
  };

  const clearCanvas = () => {
    contextRef.current.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    for (let i = 0; i < 10; i++) {
      const element = document.getElementById(`prediction-${i}`);
      element.className = "prediction-col";
      element.children[0].children[0].style.height = "0";
    }
  }

  async function updatePredictions() {
    // Get the predictions for the canvas data.
    const imgData = contextRef.current.getImageData(0, 0, CANVAS_SIZE, CANVAS_SIZE)
    const input = new Tensor(new Float32Array(imgData.data), "float32");

    const outputMap = await sess.run([input]);
    const outputTensor = outputMap.values().next().value;
    const predictions = outputTensor.data;
    const maxPrediction = Math.max(...predictions);

    for (let i = 0; i < predictions.length; i++) {
      const element = document.getElementById(`prediction-${i}`);
      element.children[0].children[0].style.height = `${predictions[i] * 100}%`;
      element.className =
        predictions[i] === maxPrediction
          ? "prediction-col top-prediction"
          : "prediction-col";
    }
  }

  return (
    <>
    <div className="text-center">
    <a href="/#"><img src={require('../../image/earth-logo-w-secai.png')} alt="co-founder-img"/></a>
    </div>
    <div className="temp22">
    <div className="card elevation">
      <canvas
        className="canvas elevation"
        id="canvas"
        onMouseDown={startDrawing}
        onMouseUp={finishDrawing}
        onMouseMove={draw}
        ref={canvasRef}
      />

      <div className="button" id="clear-button" onClick={clearCanvas}>
        CLEAR
      </div>
      <div className="predictions">
        <div className="prediction-col" id="prediction-0">
          <div className="prediction-bar-container">
            <div className="prediction-bar" />
          </div>
          <div className="prediction-number">0</div>
        </div>
        <div className="prediction-col" id="prediction-1">
          <div className="prediction-bar-container">
            <div className="prediction-bar" />
          </div>
          <div className="prediction-number">1</div>
        </div>
        <div className="prediction-col" id="prediction-2">
          <div className="prediction-bar-container">
            <div className="prediction-bar" />
          </div>
          <div className="prediction-number">2</div>
        </div>
        <div className="prediction-col" id="prediction-3">
          <div className="prediction-bar-container">
            <div className="prediction-bar" />
          </div>
          <div className="prediction-number">3</div>
        </div>
        <div className="prediction-col" id="prediction-4">
          <div className="prediction-bar-container">
            <div className="prediction-bar" />
          </div>
          <div className="prediction-number">4</div>
        </div>
        <div className="prediction-col" id="prediction-5">
          <div className="prediction-bar-container">
            <div className="prediction-bar" />
          </div>
          <div className="prediction-number">5</div>
        </div>
        <div className="prediction-col" id="prediction-6">
          <div className="prediction-bar-container">
            <div className="prediction-bar" />
          </div>
          <div className="prediction-number">6</div>
        </div>
        <div className="prediction-col" id="prediction-7">
          <div className="prediction-bar-container">
            <div className="prediction-bar" />
          </div>
          <div className="prediction-number">7</div>
        </div>
        <div className="prediction-col" id="prediction-8">
          <div className="prediction-bar-container">
            <div className="prediction-bar" />
          </div>
          <div className="prediction-number">8</div>
        </div>
        <div className="prediction-col" id="prediction-9">
          <div className="prediction-bar-container">
            <div className="prediction-bar" />
          </div>
          <div className="prediction-number">9</div>
        </div>
      </div>
    </div>
    </div>
    </>
  );
};
export default Demo1
